// utils/dateUtils.js
export const convertToUnixTimestamp = (startDate, endDate) => {
  if (!startDate || !endDate) return { startTimestamp: null, endTimestamp: null };

  const start = new Date(startDate);
  start.setHours(0, 1, 0, 0); // 00:01 AM

  // Set end date to 11:59 PM
  const end = new Date(endDate);
  end.setHours(23, 59, 0, 0); // 11:59 PM

  const startTimestamp = Math.floor(start.getTime() / 1000);
  const endTimestamp = Math.floor(end.getTime() / 1000);

  return { startTimestamp, endTimestamp };
};
